import React, { useContext } from "react"

export interface ClientConfigValue {
  clientId: string
  redirectUri?: string
  tenantId: string
}

const ClientConfigContext = React.createContext<ClientConfigValue>({
  clientId: "string",
  redirectUri: "string",
  tenantId: "string",
})

export function useClientConfig() {
  return useContext(ClientConfigContext)
}

export function ClientConfig({ config, children }: { config: ClientConfigValue, children?: React.ReactNode }) {
  return <ClientConfigContext.Provider value={config}>{children}</ClientConfigContext.Provider>
}
